import { render } from "./FinaleSection.vue?vue&type=template&id=446ed181&scoped=true"
import script from "./FinaleSection.vue?vue&type=script&lang=js"
export * from "./FinaleSection.vue?vue&type=script&lang=js"

import "./FinaleSection.vue?vue&type=style&index=0&id=446ed181&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446ed181"]])

export default __exports__